import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/select-active.png'
import _imports_1 from '@/assets/icon/select-default.png'


const _withScopeId = n => (_pushScopeId("data-v-7bac8e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { src: _imports_0 }
const _hoisted_3 = { src: _imports_1 }

interface IProps {
    modelValue: boolean;
    increaseClickArea?: boolean;
    disabled?: boolean;
  }

  interface IEmits {
    (event: 'update:modelValue', modelValue: boolean) :void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, default: false },
    increaseClickArea: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: boolean) :void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, increaseClickArea?: boolean, disabled?: boolean }

  
  
  function handleToggle() {
    if (!props.disabled) {
      emits('update:modelValue', !props.modelValue);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox", { disabled: __props.disabled }]),
    onClick: handleToggle
  }, [
    (__props.increaseClickArea)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "trigger",
          onClick: _withModifiers(handleToggle, ["stop"])
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
      [_vShow, __props.modelValue]
    ]),
    _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
      [_vShow, !__props.modelValue]
    ])
  ], 2))
}
}

})